module.exports = __webpack_public_path__ + "static/media/polar-bear_calculator.8229b415.png";